// src/config/Url.js (or wherever you keep constants)

const Url = {
//  Url: "https://api.auditusierp.com:5000",  // replace with your real backend API URL or domain
    // Url: "https://crmapi.auditusierp.com",  // replace with your real backend API URL or domain
    Url: "https://crmapi.auditusierp.com",  // replace with your real backend API URL or domain


    //  Url: "http://localhost:5000",  // replace with your real backend API URL or domain
};

export default Url;
  